export default __webpack_public_path__ + "static/media/star_7.ba27a6af.svg";